import React from 'react';
import type { Nullable } from 'corgi-types';

import { HeadlineH8, SubtitleST4 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';

interface VendorOrderIdProps {
  vendorOrderId: Nullable<string>;
  className?: string;
}

const VendorOrderId = ({ vendorOrderId, className }: VendorOrderIdProps) => {
  const { t } = useLocalization();

  return !!vendorOrderId?.length ? (
    <section className={className}>
      <HeadlineH8 as="h2">{t('h24_rauch_number_title')}:</HeadlineH8>
      <SubtitleST4>{vendorOrderId}</SubtitleST4>
    </section>
  ) : null;
};

export default VendorOrderId;
